import { INDICATOR_TYPE_RESULTS } from "../../../../../utils/const";
import FilterOfGraphs, { FilterOfGraphsProps } from "../Filters/FilterOfGraphs";
import NavigationHeader, { INavigationHeader } from "./NavigationHeader";
import { FiDownload } from "react-icons/fi";
import { MdOutlineLayers } from "react-icons/md";
import ButtonDropdown from "../../../../../components/Dropdown/ButtonDropdown";
import IconMultiSelect from "../../../../../components/Inputs/Selects/IconMultiSelect";
import { ISelectedItem } from "../../../../../components/Inputs/Selects/MultiSelectCheck";
import { CustomSelectsOption } from "../../../../../components/Inputs/Selects/CustomSelect";

export interface IHeaderOfGraphs {
    navigation: INavigationHeader,
    filterProps: FilterOfGraphsProps,
    optionsDropdownDowload: { label: string; action: () => void; }[];
    mapLayers?: {
        options: CustomSelectsOption[];
        activeLayersIds: number[];
        onSelect: (selected: ISelectedItem) => void;
        selectedItems: ISelectedItem[];
        showSelectorIcon: boolean;
    };
}

const HeaderOfGraphs = ({ navigation, filterProps, optionsDropdownDowload, mapLayers }: IHeaderOfGraphs) => {

    return (
        <div>
            <NavigationHeader {...navigation} />
            <div className={`flex ${(filterProps.typeOfIndicator === INDICATOR_TYPE_RESULTS && filterProps.filters?.length > 0) ||
                filterProps.typeOfGraph === 7 ||
                filterProps.typeOfGraph === 6
                ? 'justify-between'
                : 'justify-end'
                } items-end px-4 md:px-8 py-3 bg-brand-green-1`}
            >
                <FilterOfGraphs {...filterProps} />
                <div className="flex justify-center gap-4">
                    {mapLayers?.showSelectorIcon &&
                        <IconMultiSelect
                            icon={MdOutlineLayers}
                            label="Capas del mapa"
                            options={mapLayers?.options ?? []}
                            selectedItems={mapLayers?.selectedItems ?? []}
                            onSelect={mapLayers?.onSelect ?? (() => { })}
                            variant="outline-dark"
                        />
                    }
                    <ButtonDropdown
                        options={optionsDropdownDowload}
                        icon={FiDownload}
                        iconSize={16}
                        className="!px-3 !h-[32px]"
                    />
                </div>
            </div>
        </div>
    )
}

export default HeaderOfGraphs